import { Box, Button, TextField } from "@mui/material";
import React from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

const SearchInputEmail = ({
  setLoading,
  listAllUsers = [],
  setFilteredUsers,
  filteredUsers = [],
  searchEmail,
  setSearchEmail,
}) => {
  const { rol } = useSelector((state) => state.userReducer);
  const searchUser = async (e) => {
    try {
      setLoading(true);
      e.preventDefault();
      // console.log("Buscando:", searchEmail);
      const filtered = listAllUsers.find((user) => {
        if (user?.email === searchEmail) {
          return user;
        }
      });
      // console.log("Usuarios encontrados:", filtered);
      if (!filtered) {
        setLoading(false);
        setFilteredUsers([]);
        toast.error("Usuario no encontrado. \n Verifique el correo.");
        return;
      }
      // Actualizar el estado con los resultados filtrados
      setFilteredUsers([filtered]);
      setSearchEmail("");
      setLoading(false);
    } catch (error) {
      toast.error("Error al buscar el usuario.");
    }
  };
  return (
    <Box
      sx={{ display: "flex", gap: 2, alignItems: "center" }}
      component="form"
      onSubmit={(e) => searchUser(e)}
    >
      <TextField
        id="outlined-basic"
        label={rol === "Coach" ? "Correo del corredor" : "Correo del paciente"}
        variant="outlined"
        required
        name="email"
        type="email"
        onChange={(e) => setSearchEmail(e.target.value)}
        value={searchEmail}
      />
      <Button
        variant="contained"
        sx={{ backgroundColor: "#e7ef7d", height: 40 }}
        type="submit"
      >
        Buscar
      </Button>
      {filteredUsers && filteredUsers.length > 0 && (
        <Button
          variant="outlined"
          color="white"
          sx={{ height: 40 }}
          onClick={() => {
            setSearchEmail("");
            setFilteredUsers([]);
          }}
        >
          Limpiar filtro
        </Button>
      )}
    </Box>
  );
};

export default SearchInputEmail;
